import React from 'react';
import { Icon } from './SvgIcons';
import './CategorizedSetsDisplay.css';

const CategorizedSetsDisplay = ({ 
  sets, 
  setsByCategory, 
  onSelectSet, 
  onUnselectSet, 
  onViewDetails,
  selectedSets = [],
  isModeratorView = false 
}) => {
  
  const categoryConfig = {
    general: {
      icon: 'Book',
      label: 'General Exam',
      color: '#0066cc',
      bgColor: '#e6f2ff',
      borderColor: '#0066cc',
      description: 'Standard examination for regular students'
    },
    special: {
      icon: 'Clipboard',
      label: 'Special Case',
      color: '#ff9900',
      bgColor: '#fff4e6',
      borderColor: '#ff9900',
      description: 'Special case examination (medical reasons, etc.)'
    },
    reexam: {
      icon: 'RotateCcw',
      label: 'Re-Examination',
      color: '#cc0000',
      bgColor: '#ffe6e6',
      borderColor: '#cc0000',
      description: 'Re-examination for students who failed or missed'
    }
  };

  const getSelectionOrder = (setId) => {
    const selection = selectedSets.find(s => s.set_id === setId);
    return selection ? selection.selection_order : null;
  };

  const isSetSelected = (setId) => {
    return selectedSets.some(s => s.set_id === setId);
  };

  return (
    <div className="categorized-sets-display">
      {/* Show message if no sets */}
      {sets.length === 0 ? (
        <div style={{
          padding: '3rem 2rem',
          textAlign: 'center',
          // background: '#f5f7fa',
          borderRadius: '0.75rem',
          border: '2px dashed #ddd'
        }}>
          <p style={{ margin: '0 0 1rem 0', display: 'flex', justifyContent: 'center', color: 'var(--text-tertiary)' }}><Icon name="Clipboard" size={32} /></p>
          <p style={{ fontSize: '1.125rem', fontWeight: '600', margin: '0 0 0.5rem 0', color: 'var(--text-primary)' }}>
            No Categorized Sets Yet
          </p>
          <p style={{ margin: 0, color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
            Waiting for moderator to categorize and send sets from the pool
          </p>
        </div>
      ) : (
        <>
      {/* Category Tabs */}
      <div className="category-tabs">
        {['general', 'special', 'reexam'].map(category => {
          const config = categoryConfig[category];
          const count = setsByCategory[category]?.length || 0;
          
          return (
            <div 
              key={category}
              className="category-tab"
              style={{
                background: config.bgColor,
                borderLeft: `4px solid ${config.color}`
              }}
            >
              <div className="category-header">
                <span className="category-icon"><Icon name={config.icon} size={22} color={config.color} /></span>
                <div className="category-info">
                  <h3 className="category-title" style={{ color: config.color }}>
                    {config.label}
                  </h3>
                  <p className="category-description">{config.description}</p>
                </div>
                <span className="category-count" style={{ background: config.color, color: 'white' }}>
                  {count} set{count !== 1 ? 's' : ''}
                </span>
              </div>

              {/* Sets in this category */}
              <div className="category-sets">
                {count === 0 ? (
                  <div className="no-sets">
                    <p>No sets in this category</p>
                  </div>
                ) : (
                  setsByCategory[category].map(set => {
                    const isSelected = isSetSelected(set.set_id);
                    const selectionOrder = getSelectionOrder(set.set_id);

                    return (
                      <div 
                        key={set.set_id}
                        className={`set-card ${isSelected ? 'selected' : ''}`}
                        style={{
                          borderColor: isSelected ? config.color : '#ddd',
                          background: isSelected ? config.bgColor : '#fff'
                        }}
                      >
                        {/* Set Header */}
                        <div className="set-card-header">
                          <div className="set-number-badge" style={{ background: config.color }}>
                            Set {set.set_number}
                          </div>
                          <div className="set-badges">
                            {isSelected && (
                              <span className="selection-badge" style={{ background: config.color, display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}>
                                <Icon name="Check" size={12} /> Option {selectionOrder}
                              </span>
                            )}
                            <span className="status-badge">
                              {set.status.replace('_', ' ')}
                            </span>
                          </div>
                        </div>

                        {/* Set Details */}
                        <div className="set-card-details">
                          <div className="detail-row">
                            <span className="detail-label">Total Marks:</span>
                            <span className="detail-value">{set.total_marks}</span>
                          </div>
                          
                          <div className="detail-row">
                            <span className="detail-label">Category:</span>
                            <span className="detail-value" style={{ color: config.color, fontWeight: '600', display: 'inline-flex', alignItems: 'center', gap: '0.3rem' }}>
                              <Icon name={config.icon} size={14} /> {config.label}
                            </span>
                          </div>

                          <div className="detail-row">
                            <span className="detail-label">Created by:</span>
                            <span className="detail-value">{set.created_by_name}</span>
                          </div>

                          {isModeratorView && set.categorized_by_name && (
                            <div className="detail-row">
                              <span className="detail-label">Categorized by:</span>
                              <span className="detail-value">{set.categorized_by_name}</span>
                            </div>
                          )}

                          {isModeratorView && set.categorized_at && (
                            <div className="detail-row">
                              <span className="detail-label">Categorized:</span>
                              <span className="detail-value">
                                {new Date(set.categorized_at).toLocaleDateString()}
                              </span>
                            </div>
                          )}

                          <div className="detail-row">
                            <span className="detail-label">Sent to COE:</span>
                            <span className="detail-value">
                              {new Date(set.sent_to_coe_at).toLocaleDateString()}
                            </span>
                          </div>

                          {set.coe_comments && (
                            <div className="detail-row full-width">
                              <span className="detail-label">Comments:</span>
                              <span className="detail-value">{set.coe_comments}</span>
                            </div>
                          )}
                        </div>

                        {/* Set Actions */}
                        <div className="set-card-actions">
                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => onViewDetails(set.set_id)}
                            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.35rem' }}
                          >
                            <Icon name="Eye" size={14} /> View Questions
                          </button>

                          {!isModeratorView && (
                            <>
                              {isSelected ? (
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => onUnselectSet(set.set_id)}
                                  style={{ display: 'inline-flex', alignItems: 'center', gap: '0.35rem' }}
                                >
                                  <Icon name="X" size={14} /> Unselect
                                </button>
                              ) : (
                              <button 
                                  className="btn btn-success btn-sm"
                                  onClick={() => {
                                    // Get the next available selection order
                                    const usedOrders = selectedSets.map(s => s.selection_order);
                                    let nextOrder = 1;
                                    while (usedOrders.includes(nextOrder)) {
                                      nextOrder++;
                                    }
                                    onSelectSet(set.set_id, nextOrder);
                                  }}
                                  style={{ background: config.color, display: 'inline-flex', alignItems: 'center', gap: '0.35rem' }}
                                >
                                  <Icon name="Check" size={14} /> Select
                                </button>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Summary */}
      <div className="sets-summary">
        <div className="summary-card">
          <h4 style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}><Icon name="ChartBar" size={16} /> <span>Summary</span></h4>
          <div className="summary-stats">
            <div className="stat">
              <span className="stat-label">Total Sets:</span>
              <span className="stat-value">{sets.length}</span>
            </div>
            <div className="stat">
              <span className="stat-label">General:</span>
              <span className="stat-value" style={{ color: categoryConfig.general.color }}>
                {setsByCategory.general?.length || 0}
              </span>
            </div>
            <div className="stat">
              <span className="stat-label">Special:</span>
              <span className="stat-value" style={{ color: categoryConfig.special.color }}>
                {setsByCategory.special?.length || 0}
              </span>
            </div>
            <div className="stat">
              <span className="stat-label">Re-exam:</span>
              <span className="stat-value" style={{ color: categoryConfig.reexam.color }}>
                {setsByCategory.reexam?.length || 0}
              </span>
            </div>
          </div>
        </div>
      </div>
        </>
      )}
    </div>
  );
};

export default CategorizedSetsDisplay;
